import { render, staticRenderFns } from "./MopModifyButton.vue?vue&type=template&id=505fadd5"
import script from "./MopModifyButton.vue?vue&type=script&lang=js"
export * from "./MopModifyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports